import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import "./OnboardingModals.css";

const TWO_DAYS = 2 * 24 * 60 * 60 * 1000;

export const OnboardingWelcomeModal = ({ SubsData, subsLoaded }) => {
  const location = useLocation();
  const userStore = useSelector((s) => s.userReducer);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!subsLoaded) return;
    const user = userStore?.users?.user;
    if (!user?._id) return;
    if (location.pathname === "/" || location.pathname.includes("/admin")) return;
    if (SubsData?.isSubscription) return; // congrats modal takes priority
    const isNew =
      user.createdAt &&
      Date.now() - new Date(user.createdAt).getTime() < TWO_DAYS;
    setShow(!!isNew);
  }, [userStore, SubsData, subsLoaded]);

  if (!show) return null;

  const handleCalendar = () => {
    window.open(
      "https://calendar.google.com/calendar/render?action=TEMPLATE&text=WaqarZaka+New+Subscriber+Orientation&recur=RRULE:FREQ=WEEKLY;BYDAY=SA&details=5:00+PM+%26+9:00+PM+session",
      "_blank"
    );
    setShow(false);
  };

  return (
    <div
      className="om-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) setShow(false);
      }}
    >
      <div className="om-modal om-welcome">
        <div className="om-head om-head-orient">
          <div className="om-blob ob1" />
          <button className="om-close" onClick={() => setShow(false)}>
            &#10005;
          </button>
          <div className="om-head-inner">
            <div className="om-pill om-pill-purple">👋 Welcome Aboard</div>
            <h2 className="om-h2">Welcome to WaqarZaka.net!</h2>
            <p className="om-sub">
              You're now ready to begin your learning and trading journey with
              Waqar Zaka.
            </p>
          </div>
        </div>

        <div className="om-body">
          <div className="om-label">Get the official app</div>
          <div className="om-chip-list">
            <a
              className="om-chip"
              href="https://apps.apple.com/us/app/waqar-zaka/id6763535854"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span
                className="om-chip-ic"
                style={{ background: "#0b0b0f" }}
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 384 512"
                  fill="#fff"
                  aria-hidden="true"
                >
                  <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
                </svg>
              </span>
              <span>
                Apple App Store
                <br />
                <small>Download for iPhone &amp; iPad</small>
              </span>
            </a>
            <a
              className="om-chip"
              href="https://play.google.com/store/apps/details?id=com.godzillaapp.wz"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span
                className="om-chip-ic"
                style={{
                  background: "linear-gradient(135deg,#00c6ff,#0072ff)",
                }}
              >
                ▶
              </span>
              <span>
                Google Play Store
                <br />
                <small>Download for Android</small>
              </span>
            </a>
          </div>

          <div className="om-card">
            <div className="om-card-header">
              <h3>New Subscriber Orientation</h3>
              <span style={{ fontSize: 20 }}>🎓</span>
            </div>
            <div className="om-mini-row">
              <div className="om-mini">
                <div className="om-mini-k">Date</div>
                <div className="om-mini-v">Every Saturday</div>
              </div>
              <div className="om-mini">
                <div className="om-mini-k">Session Times</div>
                <div className="om-mini-v" style={{ fontSize: 12, lineHeight: 1.7 }}>
                  5:00 PM PKT <span style={{ color: "#9a94ad", fontWeight: 500 }}>(12:00 PM UTC)</span><br />
                  9:00 PM PKT <span style={{ color: "#9a94ad", fontWeight: 500 }}>(4:00 PM UTC)</span>
                </div>
              </div>
            </div>
            <div className="om-covers-label">
              During the orientation we'll cover:
            </div>
            <div className="om-ticks">
              {[
                "An overview of the website and application",
                "How to navigate and use the platform",
                "How to begin your learning and trading journey",
                "Important information every new subscriber should know",
                "Answers to common questions",
              ].map((t, i) => (
                <div key={i} className="om-tick">
                  <span className="om-tick-m">✓</span>
                  <span>{t}</span>
                </div>
              ))}
            </div>
          </div>
          <p className="om-note">
            Attend the session time that works best for you — please don't miss
            it. We look forward to seeing you there!
          </p>
        </div>

        <div className="om-foot">
          <button className="om-btn-ghost" onClick={() => setShow(false)}>
            Maybe Later
          </button>
          <button className="om-btn-primary" onClick={handleCalendar}>
            Add to Calendar
          </button>
        </div>
      </div>
    </div>
  );
};
